import { cloneDeep } from 'lodash';


const { Parser } = require('json2csv');


var exportNumbersHeaders = [
  {
    label: 'ID',
    value: 'id'
  },
  {
    label: 'Phone Number',
    value: 'phoneNumber'
  },
  {
    label: 'Name',
    value: 'name'
  },
  {
    label: 'Campaign ID',
    value: 'campaignId'
  },
  {
    label: 'Campaign Name',
    value: 'campaignName'
  },
  {
    label: 'Allocation Date',
    value: 'allocationDT'
  },
  {
    label: 'Last Bill Date',
    value: 'lastBillDT'
  },
  {
    label: 'Next Charge Date',
    value: 'nextChargeDT'
  },
  {
    label: 'Last Charge Date',
    value: 'lastChargeDT'
  },
  {
    label: 'Toll Free',
    value: 'isTollFree'
  },
  {
    label: 'Publisher ID',
    value: 'publisherId'
  },
  {
    label: 'Publisher Name',
    value: 'publisherName'
  },
  {
    label: 'Enabled',
    value: 'enabled'
  },
  {
    label: 'Number Pool Id',
    value: 'numberPoolId'
  },
  {
    label: 'Number Pool Name',
    value: 'numberPoolName'
  },
  {
    label: 'Tags',
    value: 'tags'
  }
];

var exportUsersHeaders = [
  {
    label: 'Name',
    value: 'name'
  },
  {
    label: 'Phone Number',
    value: 'mobileNumber'
  },
  {
    label: 'Email',
    value: 'email'
  },
  {
    label: 'Role',
    value: 'role'
  },
  {
    label: 'Invitation',
    value: 'inviteStatus'
  },
  {
    label: 'Can Export Reports',
    value: 'canExportReportValue'
  }
];

export default class CsvExportService {
  /** @ngInject **/
  constructor() {
    this.exportNumbersHeaders = cloneDeep(exportNumbersHeaders);
    this.exportUsersHeaders = cloneDeep(exportUsersHeaders);
  }

  exportCSVFile(fields, items, fileTitle) {
    this.#customizeItems(items);
    var csv = this.#convertToCSV(fields, items);
    if (csv) {
      var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportedFilenmae);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

  }

  #customizeItems(items) {
    _.forEach(items, (f) => {
      f.canExportReportValue = f.canExportReport ? 'Yes' : 'No';
    });
  }

  #convertToCSV(fields, objArray) {
    const opts = { fields };

    try {
      const parser = new Parser(opts);
      const csv = parser.parse(objArray);
      return csv;
    } catch (err) {
      console.error(err);
      return null;
    }
  }
}